import {
  createActionTypes,
  createAsyncActionTypes,
} from '../../../util/createLifeomicActionTypes';

const actionTypes = createActionTypes([
  'ACCOUNTS_PAGE_DIALOG_OPEN',
  'ACCOUNTS_PAGE_DIALOG_CLOSE',
  'ACCOUNTS_PAGE_SET_CREATED_LOGO_URL',
  'ACCOUNTS_PAGE_SET_IS_UPLOADING',
]);

const asyncActionTypes = createAsyncActionTypes([
  'ACCOUNTS_PAGE_FETCH_UPLOAD_URL',
  'ACCOUNTS_PAGE_UPLOAD_LOGO',
]);

export default {
  ...actionTypes,
  ...asyncActionTypes,
};
